import { Navigate, Outlet } from 'react-router-dom';
import { route } from '../../constants/routes';
import { isSiteAdmin } from '../auth/roles';
import { useAuthStore } from '../store/auth.store';

const SiteAdminGuard = () => {
  const roles = useAuthStore(
    (state) => state.auth?.payload?.realm_access?.roles
  );

  if (!isSiteAdmin(roles)) {
    return <Navigate to={route('/dashboard')} replace />;
  }

  return <Outlet />;
};

export default SiteAdminGuard;
